import { FC, RefObject } from 'react'

import CourseAccordeon from 'components/course/course-common/accordeon-course-wrapper/accordeon-course-wrapper'
import CourseCertificatPreview from 'components/course/course-common/course-certificat-preview/course-certificat-preview'
import CourseFinishPointsTabs from 'components/course/course-common/course-finish-points-tabs/course-finish-points-tabs'
import CourseLectorsBlock from 'components/course/course-common/course-lectors-block/course-lectors-block'
import CourseNmoRecommend from 'components/course/course-common/course-nmo-recommend/course-nmo-recommend'
import CourseTextBlock from 'components/course/course-common/course-text-block/course-text-block'
import CourseCost from 'components/course/course-common/course-cost/course-cost'
import CourseUniqPoints from 'components/course/course-common/course-uniq-points/course-uniq-points'
import HowEducationWorks from 'components/course/course-common/how-education-works/how-education-works'
import PaymentMethods from 'components/course/course-common/payment-methods/payment-methods'
import CourseSpecialties from 'components/course/course-geriatria/course-specialties/course-specialties'

import {
  FAQdata,
  OsteporosisProgram,
} from 'components/course/course-common/accordeon-course-wrapper/data'
import { dataOsteoFinishPoints } from 'components/course/course-common/course-finish-points-tabs/data'
import { osteoporosisLectors } from 'components/course/course-common/course-lectors-block/data'
import { dataOsteoporosisText } from 'components/course/course-common/course-text-block/data'
import { dataOsteoporosisUniq } from 'components/course/course-common/course-uniq-points/data'
import { osteoSpecialties } from 'components/course/course-geriatria/course-specialties/data'

import osteoStyles from 'styles/course/course-osteo.module.scss'
import styles from 'styles/course/course.module.scss'

interface IMainBlock {
  courseId: number
  refBlock: RefObject<HTMLDivElement>
  isNotAuthorized: boolean
  purchaseHandler: () => void
  price: number
}

const MainBlock: FC<IMainBlock> = ({
  courseId,
  refBlock,
  isNotAuthorized,
  purchaseHandler,
  price,
}) => {
  return (
    <main className={styles.mainContent}>
      <CourseTextBlock
        data={dataOsteoporosisText}
        ref={refBlock}
        modificator={osteoStyles.txtBlock}
      />
      <CourseUniqPoints
        data={dataOsteoporosisUniq}
        title=""
        containerModificator={osteoStyles.uniqPointsBlock}
      />
      <CourseLectorsBlock
        lectorsIds={osteoporosisLectors}
        backgroundColor="#ECECEC"
        backgroundAvatar="#E1DBCB"
        subtitle="Наши лекторы — ведущие специалисты в области остеопороза, обладающие богатым клиническим опытом и многолетней практикой. На курсе они делятся своими знаниями и отвечают на все самые важные вопросы по остеопорозу."
      />
      <CourseSpecialties specialties={osteoSpecialties} />
      <CourseAccordeon accordeonData={OsteporosisProgram} />
      <CourseFinishPointsTabs data={dataOsteoFinishPoints} minListItems={3} />
      <HowEducationWorks />
      <CourseCertificatPreview />
      <PaymentMethods />
      <CourseCost
        isNotAuthorized={isNotAuthorized}
        price={Number(price)}
        onClickOut={purchaseHandler}
      />

      <CourseAccordeon accordeonData={FAQdata} />
      <CourseNmoRecommend noShowCourses={[Number(courseId)]} />
    </main>
  )
}

export default MainBlock
